__turbopack_context__.v({
  "content": "ResultCard-module-scss-module__uarsYW__content",
  "description": "ResultCard-module-scss-module__uarsYW__description",
  "imagesContainer": "ResultCard-module-scss-module__uarsYW__imagesContainer",
  "root": "ResultCard-module-scss-module__uarsYW__root",
  "slide": "ResultCard-module-scss-module__uarsYW__slide",
  "title": "ResultCard-module-scss-module__uarsYW__title",
  "track": "ResultCard-module-scss-module__uarsYW__track",
  "trackImage": "ResultCard-module-scss-module__uarsYW__trackImage",
  "tracksWrapper": "ResultCard-module-scss-module__uarsYW__tracksWrapper",
});
